enum sensorDataChartType{
    GET_SENSOR_DATA_CHART_START='GET_SENSOR_DATA_CHART_START',
    GET_SENSOR_DATA_CHART_SUCCESS = 'GET_SENSOR_DATA_CHART_SUCCESS',
    GET_SENSOR_DATA_CHART_ERROR = 'GET_SENSOR_DATA_CHART_ERROR',
    RESET_SENSOR_DATA_CHART = 'RESET_SENSOR_DATA_CHART',
    RESET_SENSOR_DATA_CHART_SUCCESS='RESET_SENSOR_DATA_CHART_SUCCESS'
}

export default sensorDataChartType;